import getUsers from "./getUsers";
import getUserSponsors from "./getUserSponsors";
import toggleAdminStatus from "./toggleAdminStatus";
import addUserResources from "./addUserResources";
import deleteUserById from "./deleteUserById";
import getUser from "./getUser";
import { api } from "../../api";

export const usersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUsers: getUsers(build),
    getUserSponsors: getUserSponsors(build),
    toggleAdminStatus: toggleAdminStatus(build),
    addUserResources: addUserResources(build),
    deleteUserById: deleteUserById(build),
    getUser: getUser(build),
  }),
  overrideExisting: true,
});

export const {
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useGetUserSponsorsQuery,
  useLazyGetUserSponsorsQuery,
  useToggleAdminStatusMutation,
  useAddUserResourcesMutation,
  useDeleteUserByIdMutation,
  useGetUserQuery,
} = usersApi;
